
import React, { useEffect, useState } from "react";
import "../styles/Rating.css";
import axios from "axios";
import { prt } from "./prt";

export var stars = "";
const Rating = ({ autimg, ratings }) => {
  const [sentiments, setSentiments] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const analyzeSentiments = async (textRatings) => {
      try {
        const results = await Promise.all(
          textRatings.map(async (textRating) => {
            const response = await axios.post(`${prt}/analyze`, { text: textRating });
            return response.data.sentiment;
          })
        );
        setSentiments(results);
      } catch (error) {
        console.error("Error analyzing sentiments:", error);
        setError("Error analyzing sentiments.");
      } finally {
        setLoading(false);
      }
    };

    if (ratings.length > 0) {
      setLoading(true);
      analyzeSentiments(ratings);
    }
  }, [ratings]);

  const getStarRating = (sentiment) => {
    if (sentiment === "Positive") return 5;
    if (sentiment === "Neutral") return 3;
    return 1;
  };

  useEffect(() => {
    if (!loading && sentiments.length > 0) {
      const lastStarRating = getStarRating(sentiments[sentiments.length - 1]);
      stars = lastStarRating;
    }
  }, [loading, sentiments]);

  if (loading) {
    return (
      <div className="rt-rating-container">
        <div className="rt-rating-right">
          <div className="rt-skeleton-title"></div>
          {[...Array(3)].map((_, index) => (
            <div className="rt-rating-item" key={index}>
              <div className="rt-usr-cont">
                <div className="rt-usr-pic"></div>
                <div className="rt-skeleton-text"></div>
              </div>
              <div className="rt-rating-sentiment">
                <div className="rt-skeleton-star-rating"></div>
                <p className="rt-skeleton-sentiment-text"></p>
              </div>
            </div>
          ))}
        </div>
      </div>
    );

  }
  if (error) return <div className="error">{error}</div>;

  return (
    <div className="rating-container">
      <div className="rating-right">
        <h3>All Ratings:</h3>
        {ratings.map((rating, index) => {
          const sentiment = sentiments[index] || "Loading...";
          const starRating = getStarRating(sentiment);

          return (
            <div className="rating-item" key={index}>
              <div className="usr-cont">
                <img src={autimg} className="usr-pic" alt="author" />
                <p>{rating}</p>
              </div>
              <div className="rating-sentiment">
                <div className="star-rating">
                  <span className="color">
                    {"★".repeat(starRating)}
                  </span>
                  <span className="no-color">
                    {"★".repeat(5 - starRating)}
                  </span>
                </div>
                <p className="sentiment-text">Rating Sentiment:
                  <span className={starRating === 5 ? "senti pos" : starRating === 3 ? "senti neu" : "senti neg"}>
                    {sentiment}
                  </span>
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Rating;
